import React from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { BsExclamationTriangle } from "react-icons/bs";

/**
 * Shared wizard footer: Back + primary Next CTA.
 * Disabled styles use explicit colors (not opacity) so the label stays readable
 * on this project's Tailwind 2 setup, which has no `disabled:` variants.
 */
const WizardNav = ({
	onBack,
	onNext,
	backLabel = "← Back",
	nextLabel = "Continue →",
	nextDisabled = false,
	nextDisabledReason,
	backDisabled = false,
	hideBack = false,
	hideNext = false,
	busy = false,
	busyLabel = "Please wait…",
	extra = null,
}) => {
	const blocked = nextDisabled && !busy;
	const backIsDisabled = backDisabled || busy;

	const nextClassName = [
		"inline-flex h-11 items-center justify-center gap-2 rounded-lg px-5 text-sm font-semibold shadow-sm transition focus:outline-none focus:ring-2 focus:ring-akgreen focus:ring-offset-2",
		busy
			? "cursor-wait bg-akgreen text-white opacity-50"
			: blocked
			? "cursor-not-allowed border border-gray-400 bg-gray-200 text-gray-700"
			: "bg-akgreen text-white hover:bg-akgreener",
	].join(" ");

	return (
		<footer className="sticky bottom-0 z-10 -mx-6 mt-8 border-t border-gray-100 bg-white px-6 pt-5 pb-1">
			{blocked && nextDisabledReason ? (
				<div
					className="mb-3 flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900"
					role="status"
					aria-live="polite"
				>
					<BsExclamationTriangle
						className="mt-0.5 h-4 w-4 flex-shrink-0"
						aria-hidden
					/>
					<span>{nextDisabledReason}</span>
				</div>
			) : null}
			<div className="flex flex-wrap items-center justify-end gap-2">
				{!hideBack ? (
					<button
						type="button"
						className={`rounded-lg border border-gray-200 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 transition hover:border-gray-300 hover:bg-gray-50 ${
							backIsDisabled ? "cursor-not-allowed opacity-50" : ""
						}`}
						onClick={onBack}
						disabled={backIsDisabled}
					>
						{backLabel}
					</button>
				) : null}
				{extra}
				{!hideNext ? (
					<button
						type="button"
						className={nextClassName}
						onClick={onNext}
						disabled={nextDisabled || busy}
					>
						{busy ? (
							<>
								<AiOutlineLoading3Quarters
									className="h-4 w-4 animate-spin"
									aria-hidden
								/>
								{busyLabel}
							</>
						) : (
							nextLabel
						)}
					</button>
				) : null}
			</div>
		</footer>
	);
};

export default WizardNav;
